import { useRef } from 'react'

const now = () => document.timeline?.currentTime ?? performance.now()

// A CSS animation starts counting from the moment its element (or class) appears, so several
// copies that appear a few hundred milliseconds apart each spin or pulse at their own phase.
// A negative delay of "how far into the current cycle the page clock is" makes every copy behave
// as if it had been running since page load — same clock, same phase, no matter when it joined.
//
// Recomputed only when `active` changes (the animation starts then), never on an ordinary
// re-render: shifting the delay of a running animation would jump its phase.
const useSyncedAnimationDelay = (durationMs, active = true) => {
  const ref = useRef()
  if (!ref.current || ref.current.active !== active) {
    ref.current = { active, animationDelay: `-${now() % durationMs}ms` }
  }
  return active ? { animationDelay: ref.current.animationDelay } : undefined
}

export default useSyncedAnimationDelay
